<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>修改代采价日志列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.goods_name"
                      placeholder="商品名称"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_no"
                      placeholder="商品货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.city"
                      placeholder="选择城市"
                      multiple
                      @keyup.native.enter="search"
                    >
                      <el-option
                        v-for="item in citys"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.brand_name"
                      placeholder="品牌"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.woid"
                      placeholder="代采订单"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.pgid" placeholder="选择代采组">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in resData.optionsPg"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="修改时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="plan_price"
              label="商家价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="woid"
              label="代采订单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="代采单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="note"
              label="代采备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="修改人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="edit_time"
              label="修改时间"
              width="100"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        create_time: this.defaultDate(),
        city: [],
      },
      loading: false,
      url: "/erp/WcgOrder/orderPriceChangeList",
      origin: 1,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      citys: CITY,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row, index) {
      const curRow = this.resData.list[index];
      this.$router.push(
        `/home/stockdetail/${row.goods_no}?co_id=${curRow.co_id}&where=${curRow.where}&si_id=${curRow.si_id}`
      );
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.filteredForm.origin;
          this.where = this.filteredForm.where;
          this.curPage = 1;
        }
      });
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectWhere(key) {
      this.form.where = this.where = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ModifiedPurchasePriceLogList.vue